"use strict";var e=require("react");const o=e=>{const o=document.body;e?o&&(o.style.overflow="hidden"):o&&(o.style.overflow="")};var r=e.memo((({children:r,hide:l})=>(e.useEffect((()=>(o(null==l||l),()=>o(null!=l&&l))),[l]),r)));exports.OverflowHidden=r;
//# sourceMappingURL=OverflowHidden-B6cVlehK.js.map
